import styles from './NewsPage.module.scss';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import MainNav from '../components/main-nav/MainNav';
import { newsEventAction, commonActions, ratesActions } from '../../stores/_actions';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { ProfileBar } from '../components/profile-bar/ProfileBar';
import { Pagination } from 'semantic-ui-react';

function NewsPage() {
  const dispatch = useDispatch();
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const profile = JSON.parse(localStorage.getItem('userProfile'));

  useEffect(() => {
    dispatch(newsEventAction.newsEvent());
    dispatch(commonActions.getCustDetailsByCode(payload));
    dispatch(ratesActions.clearRatesData());
  }, []);

  const newEvents = useSelector((state) => state.newsEvent?.data?.response);
  const [pager, setPage] = useState({
    page: 1,
    itemsPerPage: 8,
  });
  const setPageNum = (event, { activePage }) => {
    setPage({ page: activePage });
  };
  const itemsPerPage = 8;
  const { page } = pager;
  const totalPages = Math.ceil(newEvents && newEvents.length / itemsPerPage);
  const items = newEvents && newEvents.slice((page - 1) * itemsPerPage, (page - 1) * itemsPerPage + itemsPerPage);

  const news =
    items &&
    items.map((item, index) => (
      <div className={styles.newsEvent__box + ' ' + styles.newsEvent__small}>
        <img src={item?.ImagePath} alt="" />
        <h3>
          {item?.Title}
          <span>{item?.CreatedDate}</span>
        </h3>
        <p>
          <span>Dear {item?.customer},</span>
          {item?.Matter}
        </p>
      </div>
    ));
  //   news = <p>{newEvents?.message}</p>;
  // }
  const [payload, setPayload] = useState({
    Id: null,
    Message: null,
    CustomerCode: null,
    Status: false,
    SessionID: sessionId,
    IdType: null,
    langcode: '0001',
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
  });
  const userProfile = useSelector((state) => state.getCustDetails.data);
  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              <div className={styles.newsEvent}>{news ? news : <div className={styles.spinner}></div>}</div>
              <div className={styles.pageCount}>
                <div className={styles.pageCountcont}>
                  <span>{page}</span> / <span>{totalPages}</span>
                </div>
                <div className={styles.carousal}>
                  <Pagination
                    boundaryRange={0}
                    activePage={page}
                    defaultActivePage={page}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    siblingRange={null}
                    totalPages={totalPages}
                    onPageChange={setPageNum}
                  />
                </div>
              </div>
              {/* <div className={styles.pageLeft__pageCount}>
                <div className={styles.pageLeft__pageCountcont}>
                  <span>1</span> / <span>5</span>
                </div>
                <div className={styles.carousal}>
                  <a href="#">
                    <img src={carousalL} alt="" />
                  </a>
                  <a href="#">
                    <img src={carousalR} alt="" />
                  </a>
                </div>
              </div> */}
            </div>
            <div className={styles.pageRight}>&nbsp;</div>
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { NewsPage };
